import {
  ListTasksCommandInput,
  ListTasksCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';
import { QueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { taskKeys } from 'src/data/api/helios-service-ts/task/queries/keys';
import { taskService } from 'src/data/api/helios-service-ts/task/service';

/**
 * React Query hook for listing tasks from the Helios service.
 *
 * Uses raw HTTP call instead of the TypeScript client to avoid Smithy
 * deserialization errors caused by non-RFC-3339 date fields from the backend.
 *
 * TODO: Switch back to taskService.list (TypeScript client) once the backend
 * returns date fields in RFC-3339 format.
 *
 * @param input - The input parameters for the ListTasksCommand
 * @param options - Optional React Query configuration (queryKey and queryFn cannot be overridden)
 * @returns React Query result with task list data
 */
export const useListTasksQuery = <TData = ListTasksCommandOutput>(
  input: ListTasksCommandInput,
  options?: Omit<
    UseQueryOptions<ListTasksCommandOutput, Error, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    ...options,
    queryKey: taskKeys.list(input),
    queryFn: () => taskService.listRaw(input),
  });
};
